<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>UGC QUALITY MANDATES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">UGC Quality Mandates</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="blog-style1">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <table class="table table-responsive table-bordered text-center">
                    <thead style="background-color: #e67e22; color: white;">
                    <tr>
                        <th class="bg-secondary text-center text-white" width="700">Details</th>
                        <th class="bg-secondary text-center text-white" width="700">View</th>
                    </tr>
                    </thead>
                    <tbody style="background: aliceblue; color: #e67e22; font-weight: bold;">
                    <tr>
                        <td>Exam Post Moderation Form_AU</td>
                        <td><a href="https://drive.google.com/uc?id=1HLgfrTHHmXtesmzwQWg48HBBDsdnO8kD"
                               target="_blank">View</a>
                        </td>
                    </tr>
                    <tr>
                        <td>Exam Pre Moderation Form_AU</td>
                        <td><a href="https://drive.google.com/uc?id=1VtPs_II32Hgu1GRNh5GJokBB2Kgbi7Fg"
                               target="_blank">View</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>
